import Pointer from './assets/Pointer.svg'
import Default from './assets/Default.svg'
import BasierSemi from './assets/basiercircle-semibold-webfont.ttf'
import styled, { createGlobalStyle } from 'styled-components'
import { MapContainer } from 'react-leaflet'

export default createGlobalStyle`
    @font-face {
        font-family: 'Basier';
        font-style: normal;
        font-weight: 600;
        src: local('☺'), url(${BasierSemi});
    }

    .tooltip {
        background: black;
        border: 0;
        border-radius: 6px;
        padding: 2px 10px;
        font-weight: 600;
        font-family: Basier, Arial, sans-serif;
        font-size: 12px;
        line-height: 20px;
        color: white;
        white-space: nowrap;
    }
    .tooltip::before {
        border-bottom-color: black;
    }
    .leaflet-container {
        cursor: url(${Default}), default;
    }
    .leaflet-container * {
        cursor: url(${Pointer}), pointer;
    }
`

export const StyledMap = styled(MapContainer)`
    width: 100%;
    height: 100%;
    background: linear-gradient(to bottom, #d7d7d7 50%, #f2f2f2 50%, #f2f2f2);
`
